
// @ts-nocheck


export const localeCodes =  [
  "zh-Hans",
  "en",
  "fr",
  "ko",
  "th",
  "zh-Hant",
  "af",
  "am",
  "ar",
  "as",
  "az",
  "ba",
  "be",
  "bg",
  "bho",
  "bn",
  "bo",
  "brx",
  "bs",
  "ca",
  "cs",
  "cy",
  "da",
  "de",
  "doi",
  "dsb",
  "dv",
  "el",
  "es",
  "et",
  "eu",
  "fa",
  "fi",
  "fil",
  "fj",
  "fo",
  "fr-CA",
  "ga",
  "gl",
  "gom",
  "gu",
  "ha",
  "he",
  "hi",
  "hne",
  "hr",
  "hsb",
  "ht",
  "hu",
  "hy",
  "id",
  "ig",
  "ikt",
  "is",
  "it",
  "iu",
  "iu-Latn",
  "ja",
  "ka",
  "kk",
  "km",
  "kmr",
  "kn",
  "ks",
  "ku",
  "ky",
  "lb",
  "ln",
  "lo",
  "lt",
  "lug",
  "lv",
  "lzh",
  "mai",
  "mg",
  "mi",
  "mk",
  "ml",
  "mn-Cyrl",
  "mn-Mong",
  "mni",
  "mr",
  "ms",
  "mt",
  "mww",
  "my",
  "nb",
  "ne",
  "nl",
  "nso",
  "nya",
  "or",
  "otq",
  "pa",
  "pl",
  "prs",
  "ps",
  "pt",
  "pt-PT",
  "ro",
  "ru",
  "run",
  "rw",
  "sd",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sq",
  "sr-Cyrl",
  "sr-Latn",
  "st",
  "sv",
  "sw",
  "ta",
  "te",
  "ti",
  "tk",
  "tlh-Latn",
  "tlh-Piqd",
  "tn",
  "to",
  "tr",
  "tt",
  "ty",
  "ug",
  "uk",
  "ur",
  "uz",
  "vi",
  "xh",
  "yo",
  "yua",
  "yue",
  "zu"
]

export const localeLoaders = {
  "zh-Hans": [],
  en: [],
  fr: [],
  ko: [],
  th: [],
  "zh-Hant": [],
  af: [],
  am: [],
  ar: [],
  as: [],
  az: [],
  ba: [],
  be: [],
  bg: [],
  bho: [],
  bn: [],
  bo: [],
  brx: [],
  bs: [],
  ca: [],
  cs: [],
  cy: [],
  da: [],
  de: [],
  doi: [],
  dsb: [],
  dv: [],
  el: [],
  es: [],
  et: [],
  eu: [],
  fa: [],
  fi: [],
  fil: [],
  fj: [],
  fo: [],
  "fr-CA": [],
  ga: [],
  gl: [],
  gom: [],
  gu: [],
  ha: [],
  he: [],
  hi: [],
  hne: [],
  hr: [],
  hsb: [],
  ht: [],
  hu: [],
  hy: [],
  id: [],
  ig: [],
  ikt: [],
  is: [],
  it: [],
  iu: [],
  "iu-Latn": [],
  ja: [],
  ka: [],
  kk: [],
  km: [],
  kmr: [],
  kn: [],
  ks: [],
  ku: [],
  ky: [],
  lb: [],
  ln: [],
  lo: [],
  lt: [],
  lug: [],
  lv: [],
  lzh: [],
  mai: [],
  mg: [],
  mi: [],
  mk: [],
  ml: [],
  "mn-Cyrl": [],
  "mn-Mong": [],
  mni: [],
  mr: [],
  ms: [],
  mt: [],
  mww: [],
  my: [],
  nb: [],
  ne: [],
  nl: [],
  nso: [],
  nya: [],
  or: [],
  otq: [],
  pa: [],
  pl: [],
  prs: [],
  ps: [],
  pt: [],
  "pt-PT": [],
  ro: [],
  ru: [],
  run: [],
  rw: [],
  sd: [],
  si: [],
  sk: [],
  sl: [],
  sm: [],
  sn: [],
  so: [],
  sq: [],
  "sr-Cyrl": [],
  "sr-Latn": [],
  st: [],
  sv: [],
  sw: [],
  ta: [],
  te: [],
  ti: [],
  tk: [],
  "tlh-Latn": [],
  "tlh-Piqd": [],
  tn: [],
  to: [],
  tr: [],
  tt: [],
  ty: [],
  ug: [],
  uk: [],
  ur: [],
  uz: [],
  vi: [],
  xh: [],
  yo: [],
  yua: [],
  yue: [],
  zu: []
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    "zh-Hans",
    "en",
    "fr",
    "ko",
    "th",
    "zh-Hant",
    "af",
    "am",
    "ar",
    "as",
    "az",
    "ba",
    "be",
    "bg",
    "bho",
    "bn",
    "bo",
    "brx",
    "bs",
    "ca",
    "cs",
    "cy",
    "da",
    "de",
    "doi",
    "dsb",
    "dv",
    "el",
    "es",
    "et",
    "eu",
    "fa",
    "fi",
    "fil",
    "fj",
    "fo",
    "fr-CA",
    "ga",
    "gl",
    "gom",
    "gu",
    "ha",
    "he",
    "hi",
    "hne",
    "hr",
    "hsb",
    "ht",
    "hu",
    "hy",
    "id",
    "ig",
    "ikt",
    "is",
    "it",
    "iu",
    "iu-Latn",
    "ja",
    "ka",
    "kk",
    "km",
    "kmr",
    "kn",
    "ks",
    "ku",
    "ky",
    "lb",
    "ln",
    "lo",
    "lt",
    "lug",
    "lv",
    "lzh",
    "mai",
    "mg",
    "mi",
    "mk",
    "ml",
    "mn-Cyrl",
    "mn-Mong",
    "mni",
    "mr",
    "ms",
    "mt",
    "mww",
    "my",
    "nb",
    "ne",
    "nl",
    "nso",
    "nya",
    "or",
    "otq",
    "pa",
    "pl",
    "prs",
    "ps",
    "pt",
    "pt-PT",
    "ro",
    "ru",
    "run",
    "rw",
    "sd",
    "si",
    "sk",
    "sl",
    "sm",
    "sn",
    "so",
    "sq",
    "sr-Cyrl",
    "sr-Latn",
    "st",
    "sv",
    "sw",
    "ta",
    "te",
    "ti",
    "tk",
    "tlh-Latn",
    "tlh-Piqd",
    "tn",
    "to",
    "tr",
    "tt",
    "ty",
    "ug",
    "uk",
    "ur",
    "uz",
    "vi",
    "xh",
    "yo",
    "yua",
    "yue",
    "zu"
  ],
  defaultLocale: "",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_and_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    language: "zh-Hans",
    code: "zh-Hans"
  },
  {
    language: "en",
    code: "en"
  },
  {
    language: "fr",
    code: "fr"
  },
  {
    language: "ko",
    code: "ko"
  },
  {
    language: "th",
    code: "th"
  },
  {
    language: "zh-Hant",
    code: "zh-Hant"
  },
  {
    language: "af",
    code: "af"
  },
  {
    language: "am",
    code: "am"
  },
  {
    language: "ar",
    code: "ar"
  },
  {
    language: "as",
    code: "as"
  },
  {
    language: "az",
    code: "az"
  },
  {
    language: "ba",
    code: "ba"
  },
  {
    language: "be",
    code: "be"
  },
  {
    language: "bg",
    code: "bg"
  },
  {
    language: "bho",
    code: "bho"
  },
  {
    language: "bn",
    code: "bn"
  },
  {
    language: "bo",
    code: "bo"
  },
  {
    language: "brx",
    code: "brx"
  },
  {
    language: "bs",
    code: "bs"
  },
  {
    language: "ca",
    code: "ca"
  },
  {
    language: "cs",
    code: "cs"
  },
  {
    language: "cy",
    code: "cy"
  },
  {
    language: "da",
    code: "da"
  },
  {
    language: "de",
    code: "de"
  },
  {
    language: "doi",
    code: "doi"
  },
  {
    language: "dsb",
    code: "dsb"
  },
  {
    language: "dv",
    code: "dv"
  },
  {
    language: "el",
    code: "el"
  },
  {
    language: "es",
    code: "es"
  },
  {
    language: "et",
    code: "et"
  },
  {
    language: "eu",
    code: "eu"
  },
  {
    language: "fa",
    code: "fa"
  },
  {
    language: "fi",
    code: "fi"
  },
  {
    language: "fil",
    code: "fil"
  },
  {
    language: "fj",
    code: "fj"
  },
  {
    language: "fo",
    code: "fo"
  },
  {
    language: "fr-CA",
    code: "fr-CA"
  },
  {
    language: "ga",
    code: "ga"
  },
  {
    language: "gl",
    code: "gl"
  },
  {
    language: "gom",
    code: "gom"
  },
  {
    language: "gu",
    code: "gu"
  },
  {
    language: "ha",
    code: "ha"
  },
  {
    language: "he",
    code: "he"
  },
  {
    language: "hi",
    code: "hi"
  },
  {
    language: "hne",
    code: "hne"
  },
  {
    language: "hr",
    code: "hr"
  },
  {
    language: "hsb",
    code: "hsb"
  },
  {
    language: "ht",
    code: "ht"
  },
  {
    language: "hu",
    code: "hu"
  },
  {
    language: "hy",
    code: "hy"
  },
  {
    language: "id",
    code: "id"
  },
  {
    language: "ig",
    code: "ig"
  },
  {
    language: "ikt",
    code: "ikt"
  },
  {
    language: "is",
    code: "is"
  },
  {
    language: "it",
    code: "it"
  },
  {
    language: "iu",
    code: "iu"
  },
  {
    language: "iu-Latn",
    code: "iu-Latn"
  },
  {
    language: "ja",
    code: "ja"
  },
  {
    language: "ka",
    code: "ka"
  },
  {
    language: "kk",
    code: "kk"
  },
  {
    language: "km",
    code: "km"
  },
  {
    language: "kmr",
    code: "kmr"
  },
  {
    language: "kn",
    code: "kn"
  },
  {
    language: "ks",
    code: "ks"
  },
  {
    language: "ku",
    code: "ku"
  },
  {
    language: "ky",
    code: "ky"
  },
  {
    language: "lb",
    code: "lb"
  },
  {
    language: "ln",
    code: "ln"
  },
  {
    language: "lo",
    code: "lo"
  },
  {
    language: "lt",
    code: "lt"
  },
  {
    language: "lug",
    code: "lug"
  },
  {
    language: "lv",
    code: "lv"
  },
  {
    language: "lzh",
    code: "lzh"
  },
  {
    language: "mai",
    code: "mai"
  },
  {
    language: "mg",
    code: "mg"
  },
  {
    language: "mi",
    code: "mi"
  },
  {
    language: "mk",
    code: "mk"
  },
  {
    language: "ml",
    code: "ml"
  },
  {
    language: "mn-Cyrl",
    code: "mn-Cyrl"
  },
  {
    language: "mn-Mong",
    code: "mn-Mong"
  },
  {
    language: "mni",
    code: "mni"
  },
  {
    language: "mr",
    code: "mr"
  },
  {
    language: "ms",
    code: "ms"
  },
  {
    language: "mt",
    code: "mt"
  },
  {
    language: "mww",
    code: "mww"
  },
  {
    language: "my",
    code: "my"
  },
  {
    language: "nb",
    code: "nb"
  },
  {
    language: "ne",
    code: "ne"
  },
  {
    language: "nl",
    code: "nl"
  },
  {
    language: "nso",
    code: "nso"
  },
  {
    language: "nya",
    code: "nya"
  },
  {
    language: "or",
    code: "or"
  },
  {
    language: "otq",
    code: "otq"
  },
  {
    language: "pa",
    code: "pa"
  },
  {
    language: "pl",
    code: "pl"
  },
  {
    language: "prs",
    code: "prs"
  },
  {
    language: "ps",
    code: "ps"
  },
  {
    language: "pt",
    code: "pt"
  },
  {
    language: "pt-PT",
    code: "pt-PT"
  },
  {
    language: "ro",
    code: "ro"
  },
  {
    language: "ru",
    code: "ru"
  },
  {
    language: "run",
    code: "run"
  },
  {
    language: "rw",
    code: "rw"
  },
  {
    language: "sd",
    code: "sd"
  },
  {
    language: "si",
    code: "si"
  },
  {
    language: "sk",
    code: "sk"
  },
  {
    language: "sl",
    code: "sl"
  },
  {
    language: "sm",
    code: "sm"
  },
  {
    language: "sn",
    code: "sn"
  },
  {
    language: "so",
    code: "so"
  },
  {
    language: "sq",
    code: "sq"
  },
  {
    language: "sr-Cyrl",
    code: "sr-Cyrl"
  },
  {
    language: "sr-Latn",
    code: "sr-Latn"
  },
  {
    language: "st",
    code: "st"
  },
  {
    language: "sv",
    code: "sv"
  },
  {
    language: "sw",
    code: "sw"
  },
  {
    language: "ta",
    code: "ta"
  },
  {
    language: "te",
    code: "te"
  },
  {
    language: "ti",
    code: "ti"
  },
  {
    language: "tk",
    code: "tk"
  },
  {
    language: "tlh-Latn",
    code: "tlh-Latn"
  },
  {
    language: "tlh-Piqd",
    code: "tlh-Piqd"
  },
  {
    language: "tn",
    code: "tn"
  },
  {
    language: "to",
    code: "to"
  },
  {
    language: "tr",
    code: "tr"
  },
  {
    language: "tt",
    code: "tt"
  },
  {
    language: "ty",
    code: "ty"
  },
  {
    language: "ug",
    code: "ug"
  },
  {
    language: "uk",
    code: "uk"
  },
  {
    language: "ur",
    code: "ur"
  },
  {
    language: "uz",
    code: "uz"
  },
  {
    language: "vi",
    code: "vi"
  },
  {
    language: "xh",
    code: "xh"
  },
  {
    language: "yo",
    code: "yo"
  },
  {
    language: "yua",
    code: "yua"
  },
  {
    language: "yue",
    code: "yue"
  },
  {
    language: "zu",
    code: "zu"
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/